import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { Check, Loader2, X } from "lucide-react";
import { api, apiError } from "@/lib/api";

export default function ReviewModerate() {
  const { id, token } = useParams();
  const [r, setR] = useState(null);
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState("");
  const [done, setDone] = useState(null);

  useEffect(() => {
    api.get(`/reviews/${id}/moderation`, { params: { token } })
      .then((res) => setR(res.data))
      .catch((e) => setErr(apiError(e.response?.data?.detail)));
  }, [id, token]);

  const decide = async (action) => {
    setBusy(action);
    try {
      const { data } = await api.post(`/reviews/${id}/moderation`, { token, action });
      setDone(data.published ? "approved" : "rejected");
      toast.success(data.published ? "Avis publié sur le site" : "Avis refusé, il reste masqué");
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
    } finally {
      setBusy("");
    }
  };

  if (err) return <div className="py-40 text-center text-sm text-bone/72" data-testid="review-moderate-error">{err}</div>;
  if (!r) return <div className="py-40 text-center text-xs uppercase tracking-[0.3em] text-bone/76">Chargement…</div>;

  const treated = done || (r.moderated ? (r.published ? "approved" : "rejected") : null);

  return (
    <div className="mx-auto max-w-2xl px-6 py-20" data-testid="review-moderate-page">
      <p className="eyebrow">Espace propriétaire</p>
      <h1 className="display-xl mt-6 text-4xl text-bone">Nouvel avis à valider</h1>

      <div className="panel mt-10 p-8 text-sm">
        <div className="flex items-center justify-between">
          <span className="text-brass text-[11px]">{"★".repeat(r.rating)}</span>
          <span className="text-[10px] uppercase tracking-[0.24em] text-bone/72">{r.source}</span>
        </div>
        <p className="mt-6 font-display text-xl leading-relaxed text-bone/85" data-testid="review-moderate-text">« {r.text} »</p>
        <p className="mt-7 text-[10px] uppercase tracking-[0.24em] text-bone/72">
          {r.author}{r.date ? ` · ${r.date}` : ""}
        </p>
      </div>

      {treated ? (
        <p className="mt-10 border border-white/10 bg-panel p-8 text-center text-sm text-bone/72" data-testid="review-moderate-done">
          {treated === "approved"
            ? "Avis approuvé : il est désormais affiché sur le site."
            : "Avis refusé : il n'apparaît pas sur le site."}
        </p>
      ) : (
        <div className="mt-10 flex flex-wrap gap-5">
          <button onClick={() => decide("approve")} disabled={!!busy} className="btn-primary" data-testid="review-moderate-approve">
            {busy === "approve" ? <Loader2 size={15} className="animate-spin" /> : <Check size={15} />} Afficher sur le site
          </button>
          <button onClick={() => decide("reject")} disabled={!!busy} className="btn-ghost" data-testid="review-moderate-reject">
            {busy === "reject" ? <Loader2 size={15} className="animate-spin" /> : <X size={15} />} Refuser
          </button>
        </div>
      )}
    </div>
  );
}
